import { render, staticRenderFns } from "./AssignModule.vue?vue&type=template&id=5d56893b&scoped=true&"
import script from "./AssignModule.vue?vue&type=script&lang=js&"
export * from "./AssignModule.vue?vue&type=script&lang=js&"
import style0 from "./AssignModule.vue?vue&type=style&index=0&id=5d56893b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d56893b",
  null
  
)

export default component.exports